import styles from '@/styles/material-dashboard/_variables.scss'
export default {
  primary: styles.primary,
  secondary: styles.secondary,
  tertiary: styles.tertiary,
  accent: styles.accent,
  error: styles.error,
  info: styles.info,
  success: styles.success,
  warning: styles.warning
}
